

// import React, { useState, useEffect, useCallback } from 'react';
// import { getServices, createService, updateService, deleteService } from '../../utils/api';
// import toast from 'react-hot-toast';
// import { Link } from 'react-router-dom';
// const ServiceManager = ({ editingId }) => {
//     const [services, setServices] = useState([]);
//     const [loading, setLoading] = useState(true);
//     const [showForm, setShowForm] = useState(false);
//     const [currentServiceId, setCurrentServiceId] = useState(null);
//     const [uploading, setUploading] = useState(false);
//     const [uploadProgress, setUploadProgress] = useState(0);
//     const [formData, setFormData] = useState({
//         category: '',
//         title: '',
//         description: '',
//         image_url: '',
//         image_file: null,
//         is_active: true,
//         details: { services: [] }
//     });

//     // Your Railway file server URL
//     const FILE_SERVER_URL = 'https://nkumbufileserver-production.up.railway.app';

//     const loadServices = useCallback(async () => {
//         try {
//             setLoading(true);
//             const data = await getServices();
            
//             if (Array.isArray(data)) {
//                 setServices(data);
//             } else if (data && data.data && Array.isArray(data.data)) {
//                 setServices(data.data);
//             } else if (data && Array.isArray(data.services)) {
//                 setServices(data.services);
//             } else {
//                 console.error('Unexpected data structure:', data);
//                 setServices([]);
//                 toast.error('Invalid data format received from server');
//             }
//         } catch (error) {
//             console.error('Error loading services:', error);
//             toast.error('Failed to load services');
//             setServices([]);
//         } finally {
//             setLoading(false);
//         }
//     }, []);

//     useEffect(() => {
//         loadServices();
//     }, [loadServices]);

//     // Handle editing when editingId changes
//     useEffect(() => {
//         if (editingId) {
//             const serviceToEdit = services.find(s => s.id === editingId);
//             if (serviceToEdit) {
//                 setCurrentServiceId(editingId);
//                 setFormData({
//                     category: serviceToEdit.category || '',
//                     title: serviceToEdit.title || '',
//                     description: serviceToEdit.description || '',
//                     image_url: serviceToEdit.image_url || '',
//                     image_file: null,
//                     is_active: serviceToEdit.is_active !== undefined ? serviceToEdit.is_active : true,
//                     details: serviceToEdit.details || { services: [] }
//                 });
//                 setShowForm(true);
//             }
//         }
//     }, [editingId, services]);

//     // Upload file to Railway file server
//     const uploadToFileServer = async (file) => {
//         setUploading(true);
//         setUploadProgress(0);
        
//         try {
//             const formData = new FormData();
//             formData.append('file', file);

//             // Create a new XMLHttpRequest for progress tracking
//             return new Promise((resolve, reject) => {
//                 const xhr = new XMLHttpRequest();
                
//                 xhr.upload.addEventListener('progress', (event) => {
//                     if (event.lengthComputable) {
//                         const percentComplete = (event.loaded / event.total) * 100;
//                         setUploadProgress(Math.round(percentComplete));
//                     }
//                 });

//                 xhr.addEventListener('load', () => {
//                     if (xhr.status === 200) {
//                         const response = JSON.parse(xhr.responseText);
//                         setUploading(false);
//                         setUploadProgress(0);
//                         resolve(response.fileInfo.fileUrl);
//                     } else {
//                         reject(new Error(`Upload failed with status ${xhr.status}`));
//                     }
//                 });

//                 xhr.addEventListener('error', () => {
//                     reject(new Error('Upload failed'));
//                 });

//                 xhr.open('POST', `${FILE_SERVER_URL}/upload`);
//                 xhr.send(formData);
//             });
//         } catch (error) {
//             setUploading(false);
//             setUploadProgress(0);
//             console.error('Upload error:', error);
//             throw error;
//         }
//     };

//     // Handle file selection
//     const handleFileSelect = (e) => {
//         const file = e.target.files[0];
//         if (!file) return;

//         // Validate file size (max 100MB)
//         const maxSize = 100 * 1024 * 1024; // 100MB in bytes
//         if (file.size > maxSize) {
//             toast.error('File size exceeds 100MB limit');
//             return;
//         }

//         // Validate file type
//         const allowedTypes = ['image/jpeg', 'image/png', 'image/gif', 'image/webp', 'image/svg+xml'];
//         if (!allowedTypes.includes(file.type)) {
//             toast.error('Please select an image file (JPEG, PNG, GIF, WebP, SVG)');
//             return;
//         }

//         setFormData(prev => ({
//             ...prev,
//             image_file: file,
//             image_url: URL.createObjectURL(file) // Preview URL
//         }));
//     };

//     const handleSubmit = async (e) => {
//         e.preventDefault();
        
//         try {
//             let imageUrl = formData.image_url;

//             // If a new file is selected, upload it to the file server
//             if (formData.image_file) {
//                 toast.loading('Uploading image to file server...');
//                 imageUrl = await uploadToFileServer(formData.image_file);
//                 toast.dismiss();
//                 toast.success('Image uploaded successfully!');
//             }

//             // Prepare service data
//             const serviceData = {
//                 category: formData.category,
//                 title: formData.title,
//                 description: formData.description,
//                 image_url: imageUrl,
//                 is_active: formData.is_active,
//                 details: formData.details
//             };

//             if (currentServiceId) {
//                 // Update existing service
//                 console.log('Updating service with ID:', currentServiceId);
//                 await updateService(currentServiceId, serviceData);
//                 toast.success('Service updated successfully!');
//             } else {
//                 // Create new service
//                 console.log('Creating new service');
//                 await createService(serviceData);
//                 toast.success('Service created successfully!');
//             }
            
//             // Reset form
//             resetForm();
            
//             // Reload services
//             await loadServices();
            
//         } catch (error) {
//             console.error('Error saving service:', error);
//             const errorMessage = error.response?.data?.message || error.message || 'Failed to save service';
//             toast.error(errorMessage);
//         }
//     };

//     const handleDelete = async (id) => {
//         if (window.confirm('Are you sure you want to delete this service?')) {
//             try {
//                 await deleteService(id);
//                 toast.success('Service deleted successfully!');
//                 await loadServices();
//             } catch (error) {
//                 console.error('Error deleting service:', error);
//                 toast.error('Failed to delete service');
//             }
//         }
//     };

//     const handleToggleActive = async (id, currentStatus) => {
//         try {
//             await updateService(id, { is_active: !currentStatus });
//             toast.success(`Service ${!currentStatus ? 'activated' : 'deactivated'}`);
//             await loadServices();
//         } catch (error) {
//             console.error('Error toggling service status:', error);
//             toast.error('Failed to update service status');
//         }
//     };

//     const resetForm = () => {
//         setFormData({
//             category: '',
//             title: '',
//             description: '',
//             image_url: '',
//             image_file: null,
//             is_active: true,
//             details: { services: [] }
//         });
//         setCurrentServiceId(null);
//         setShowForm(false);
//         setUploadProgress(0);
//         setUploading(false);
        
//         // Clear editingId from URL if present
//         if (editingId) {
//             window.history.pushState({}, '', '/admin/services');
//         }
//     };

//     const handleEditClick = (service) => {
//         setCurrentServiceId(service.id);
//         setFormData({
//             category: service.category || '',
//             title: service.title || '',
//             description: service.description || '',
//             image_url: service.image_url || '',
//             image_file: null,
//             is_active: service.is_active !== undefined ? service.is_active : true,
//             details: service.details || { services: [] }
//         });
//         setShowForm(true);
//     };

//     const handleAddNewClick = () => {
//         resetForm();
//         setShowForm(true);
//     };

//     const handleCancelClick = () => {
//         resetForm();
//         if (editingId) {
//             window.history.pushState({}, '', '/admin/services');
//         }
//     };

//     const handleClearImage = () => {
//         setFormData(prev => ({
//             ...prev,
//             image_file: null,
//             image_url: ''
//         }));
//     };

//     return (
//         <div className="bg-white p-6 rounded-lg shadow">
//             <div className="flex justify-between items-center mb-6">
//                 <h2 className="text-2xl font-bold text-gray-800">Manage Services</h2>
//                 <button
//                     onClick={handleAddNewClick}
//                     className="bg-blue-600 text-white px-4 py-2 rounded-lg hover:bg-blue-700 transition-colors"
//                 >
//                     Add New Service
//                 </button>
//             </div>

//             {showForm && (
//                 <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
//                     <div className="bg-white p-6 rounded-lg w-full max-w-2xl max-h-[90vh] overflow-y-auto">
//                         <div className="flex justify-between items-center mb-4">
//                             <h3 className="text-xl font-bold">
//                                 {currentServiceId ? 'Edit Service' : 'Add New Service'}
//                             </h3>
//                             <button
//                                 onClick={handleCancelClick}
//                                 className="text-gray-500 hover:text-gray-700"
//                             >
//                                 ✕
//                             </button>
//                         </div>
                        
//                         <form onSubmit={handleSubmit} className="space-y-4">
//                             <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
//                                 <div>
//                                     <label className="block text-sm font-medium text-gray-700 mb-1">
//                                         Category *
//                                     </label>
//                                     <input
//                                         type="text"
//                                         value={formData.category}
//                                         onChange={(e) => setFormData({...formData, category: e.target.value})}
//                                         className="w-full p-2 border border-gray-300 rounded focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
//                                         required
//                                     />
//                                 </div>
                                
//                                 <div>
//                                     <label className="block text-sm font-medium text-gray-700 mb-1">
//                                         Title *
//                                     </label>
//                                     <input
//                                         type="text"
//                                         value={formData.title}
//                                         onChange={(e) => setFormData({...formData, title: e.target.value})}
//                                         className="w-full p-2 border border-gray-300 rounded focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
//                                         required
//                                     />
//                                 </div>
                                
//                                 <div className="md:col-span-2">
//                                     <label className="block text-sm font-medium text-gray-700 mb-1">
//                                         Description
//                                     </label>
//                                     <textarea
//                                         value={formData.description}
//                                         onChange={(e) => setFormData({...formData, description: e.target.value})}
//                                         className="w-full p-2 border border-gray-300 rounded focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
//                                         rows="4"
//                                     />
//                                 </div>
                                
//                                 <div className="md:col-span-2">
//                                     <label className="block text-sm font-medium text-gray-700 mb-1">
//                                         Service Image
//                                     </label>
                                    
//                                     {/* Upload Section */}
//                                     <div className="space-y-4">
//                                         {/* File Upload */}
//                                         <div className="border-2 border-dashed border-gray-300 rounded-lg p-6 text-center">
//                                             <input
//                                                 type="file"
//                                                 id="image-upload"
//                                                 onChange={handleFileSelect}
//                                                 accept="image/*"
//                                                 className="hidden"
//                                             />
//                                             <label
//                                                 htmlFor="image-upload"
//                                                 className="cursor-pointer"
//                                             >
//                                                 <div className="flex flex-col items-center">
//                                                     <svg className="w-12 h-12 text-gray-400 mb-3" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
//                                                         <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z"></path>
//                                                     </svg>
//                                                     <p className="text-sm text-gray-600 mb-2">
//                                                         <span className="font-semibold">Click to upload</span> or drag and drop
//                                                     </p>
//                                                     <p className="text-xs text-gray-500">
//                                                         PNG, JPG, GIF, WebP, SVG up to 100MB
//                                                     </p>
//                                                 </div>
//                                             </label>
//                                         </div>

//                                         {/* Upload Progress */}
//                                         {uploading && (
//                                             <div className="w-full">
//                                                 <div className="flex justify-between text-sm text-gray-600 mb-1">
//                                                     <span>Uploading...</span>
//                                                     <span>{uploadProgress}%</span>
//                                                 </div>
//                                                 <div className="w-full bg-gray-200 rounded-full h-2">
//                                                     <div 
//                                                         className="bg-blue-600 h-2 rounded-full transition-all duration-300"
//                                                         style={{ width: `${uploadProgress}%` }}
//                                                     ></div>
//                                                 </div>
//                                             </div>
//                                         )}

//                                         {/* Image Preview */}
//                                         {formData.image_url && (
//                                             <div className="relative">
//                                                 <p className="text-sm text-gray-600 mb-2">Preview:</p>
//                                                 <div className="relative inline-block">
//                                                     <img 
//                                                         src={formData.image_url} 
//                                                         alt="Preview"
//                                                         className="max-w-full h-48 object-cover rounded border"
//                                                         onError={(e) => {
//                                                             e.target.onerror = null;
//                                                             e.target.src = '/default-service.jpg';
//                                                         }}
//                                                     />
//                                                     <button
//                                                         type="button"
//                                                         onClick={handleClearImage}
//                                                         className="absolute top-2 right-2 bg-red-500 text-white rounded-full p-1 hover:bg-red-600"
//                                                     >
//                                                         <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
//                                                             <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12"></path>
//                                                         </svg>
//                                                     </button>
//                                                 </div>
//                                             </div>
//                                         )}

//                                         {/* Current Image URL (for editing) */}
//                                         {currentServiceId && formData.image_url && !formData.image_file && (
//                                             <div>
//                                                 <p className="text-sm text-gray-600 mb-1">Current Image URL:</p>
//                                                 <input
//                                                     type="text"
//                                                     value={formData.image_url}
//                                                     onChange={(e) => setFormData({...formData, image_url: e.target.value})}
//                                                     className="w-full p-2 border border-gray-300 rounded text-sm"
//                                                     placeholder="Or enter image URL directly"
//                                                 />
//                                             </div>
//                                         )}

//                                         {/* Direct URL Input */}
//                                         <div>
//                                             <p className="text-sm text-gray-600 mb-1">Or enter image URL directly:</p>
//                                             <input
//                                                 type="url"
//                                                 value={formData.image_file ? '' : formData.image_url}
//                                                 onChange={(e) => setFormData({...formData, image_url: e.target.value, image_file: null})}
//                                                 className="w-full p-2 border border-gray-300 rounded focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
//                                                 placeholder="https://example.com/image.jpg"
//                                                 disabled={uploading}
//                                             />
//                                         </div>
//                                     </div>
//                                 </div>
                                
//                                 <div>
//                                     <label className="flex items-center space-x-2">
//                                         <input
//                                             type="checkbox"
//                                             checked={formData.is_active}
//                                             onChange={(e) => setFormData({...formData, is_active: e.target.checked})}
//                                             className="rounded text-blue-600 focus:ring-blue-500"
//                                             disabled={uploading}
//                                         />
//                                         <span className="text-sm text-gray-700">Active</span>
//                                     </label>
//                                 </div>
//                             </div>
                            
//                             <div className="flex justify-end space-x-3 pt-4">
//                                 <button
//                                     type="button"
//                                     onClick={handleCancelClick}
//                                     className="px-4 py-2 border border-gray-300 text-gray-700 rounded hover:bg-gray-50 disabled:opacity-50"
//                                     disabled={uploading}
//                                 >
//                                     Cancel
//                                 </button>
//                                 <button
//                                     type="submit"
//                                     className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700 disabled:opacity-50 disabled:cursor-not-allowed"
//                                     disabled={uploading}
//                                 >
//                                     {uploading ? (
//                                         <span className="flex items-center">
//                                             <svg className="animate-spin -ml-1 mr-3 h-4 w-4 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
//                                                 <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
//                                                 <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
//                                             </svg>
//                                             Uploading...
//                                         </span>
//                                     ) : currentServiceId ? 'Update Service' : 'Create Service'}
//                                 </button>
//                             </div>
//                         </form>
//                     </div>
//                 </div>
//             )}

//             {loading ? (
//                 <div className="flex justify-center items-center h-64">
//                     <div className="text-center">
//                         <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto"></div>
//                         <p className="mt-4 text-gray-600">Loading services...</p>
//                     </div>
//                 </div>
//             ) : services.length === 0 ? (
//                 <div className="text-center py-12">
//                     <p className="text-gray-500 text-lg">No services found</p>
//                     <p className="text-gray-400 mt-2">Add your first service to get started</p>
//                 </div>
//             ) : (
//                 <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
//                     {services.map(service => (
//                         <div key={service.id} className="border border-gray-200 rounded-lg p-4 hover:shadow-md transition-shadow">
//                             {service.image_url && (
//                                 <img 
//                                     src={service.image_url} 
//                                     alt={service.title}
//                                     className="w-full h-48 object-cover rounded mb-4"
//                                     onError={(e) => {
//                                         e.target.onerror = null;
//                                         e.target.src = '/default-service.jpg';
//                                     }}
//                                 />
//                             )}
//                             <div className="flex justify-between items-start mb-2">
//                                 <h3 className="font-semibold text-lg text-gray-800">{service.title}</h3>
//                                 <button
//                                     onClick={() => handleToggleActive(service.id, service.is_active)}
//                                     className={`px-2 py-1 rounded text-xs ${
//                                         service.is_active 
//                                             ? 'bg-green-100 text-green-800' 
//                                             : 'bg-red-100 text-red-800'
//                                     }`}
//                                 >
//                                     {service.is_active ? 'Active' : 'Inactive'}
//                                 </button>
//                             </div>
//                             <p className="text-gray-600 text-sm mb-2">
//                                 <span className="font-medium">Category:</span> {service.category || 'Uncategorized'}
//                             </p>
//                             <p className="text-gray-700 mb-4 line-clamp-3">{service.description}</p>
//                             <div className="flex justify-between items-center pt-4 border-t">
//                                 <div className="flex space-x-2">
//                                     <button
//                                         onClick={() => handleEditClick(service)}
//                                         className="text-blue-600 hover:text-blue-800 text-sm font-medium"
//                                     >
//                                         Edit
//                                     </button>



//                                     <Link
//                                     to={`/admin/services/${service.id}`}
//                                     className="text-green-600 hover:text-green-800 text-sm font-medium"
//                                     >
//                                     View Details
//                                     </Link>

//                                     <button
//                                         onClick={() => handleDelete(service.id)}
//                                         className="text-red-600 hover:text-red-800 text-sm font-medium"
//                                     >
//                                         Delete
//                                     </button>
//                                 </div>
//                             </div>
//                         </div>
//                     ))}
//                 </div>
//             )}
//         </div>
//     );
// };

// export default ServiceManager;





import React, { useState, useEffect, useCallback } from 'react';
import { getServices, createService, updateService, deleteService } from '../../utils/api';
import toast from 'react-hot-toast';
import { Link } from 'react-router-dom';

const ServiceManager = ({ editingId }) => {
    const [services, setServices] = useState([]);
    const [loading, setLoading] = useState(true);
    const [showForm, setShowForm] = useState(false);
    const [currentServiceId, setCurrentServiceId] = useState(null);
    const [uploading, setUploading] = useState(false);
    const [uploadProgress, setUploadProgress] = useState(0);
    const [serviceItems, setServiceItems] = useState(['']);
    const [additionalImages, setAdditionalImages] = useState([]);
    
    const [formData, setFormData] = useState({
        category: '',
        title: '',
        description: '',
        image_url: '',
        image_file: null,
        is_active: true,
        details: { 
            services: [],
            additionalImages: []
        }
    });

    // Your Railway file server URL
    const FILE_SERVER_URL = 'https://nkumbufileserver-production.up.railway.app';

    const loadServices = useCallback(async () => {
        try {
            setLoading(true);
            const data = await getServices();
            
            if (Array.isArray(data)) {
                setServices(data);
            } else if (data && data.data && Array.isArray(data.data)) {
                setServices(data.data);
            } else if (data && Array.isArray(data.services)) {
                setServices(data.services);
            } else {
                console.error('Unexpected data structure:', data);
                setServices([]);
                toast.error('Invalid data format received from server');
            }
        } catch (error) {
            console.error('Error loading services:', error);
            toast.error('Failed to load services');
            setServices([]);
        } finally {
            setLoading(false);
        }
    }, []);

    useEffect(() => {
        loadServices();
    }, [loadServices]);

    // Handle editing when editingId changes
    useEffect(() => {
        if (editingId) {
            const serviceToEdit = services.find(s => s.id === editingId);
            if (serviceToEdit) {
                setCurrentServiceId(editingId);
                
                // Parse details if it's a string
                let details = serviceToEdit.details;
                if (typeof details === 'string') {
                    try {
                        details = JSON.parse(details);
                    } catch (e) {
                        details = { services: [], additionalImages: [] };
                    }
                }
                
                // Initialize arrays if not present
                if (!details.services) details.services = [];
                if (!details.additionalImages) details.additionalImages = [];
                
                setFormData({
                    category: serviceToEdit.category || '',
                    title: serviceToEdit.title || '',
                    description: serviceToEdit.description || '',
                    image_url: serviceToEdit.image_url || '',
                    image_file: null,
                    is_active: serviceToEdit.is_active !== undefined ? serviceToEdit.is_active : true,
                    details: details
                });
                
                // Set service items and additional images for editing
                setServiceItems(details.services.length > 0 ? [...details.services, ''] : ['']);
                setAdditionalImages(details.additionalImages || []);
                setShowForm(true);
            }
        }
    }, [editingId, services]);

    // Upload file to Railway file server
    const uploadToFileServer = async (file) => {
        setUploading(true);
        setUploadProgress(0);
        
        try {
            const formData = new FormData();
            formData.append('file', file);

            // Create a new XMLHttpRequest for progress tracking
            return new Promise((resolve, reject) => {
                const xhr = new XMLHttpRequest();
                
                xhr.upload.addEventListener('progress', (event) => {
                    if (event.lengthComputable) {
                        const percentComplete = (event.loaded / event.total) * 100;
                        setUploadProgress(Math.round(percentComplete));
                    }
                });

                xhr.addEventListener('load', () => {
                    if (xhr.status === 200) {
                        const response = JSON.parse(xhr.responseText);
                        setUploading(false);
                        setUploadProgress(0);
                        resolve(response.fileInfo.fileUrl);
                    } else {
                        reject(new Error(`Upload failed with status ${xhr.status}`));
                    }
                });

                xhr.addEventListener('error', () => {
                    reject(new Error('Upload failed'));
                });

                xhr.open('POST', `${FILE_SERVER_URL}/upload`);
                xhr.send(formData);
            });
        } catch (error) {
            setUploading(false);
            setUploadProgress(0);
            console.error('Upload error:', error);
            throw error;
        }
    };

    // Handle file selection for main image
    const handleFileSelect = (e) => {
        const file = e.target.files[0];
        if (!file) return;

        // Validate file size (max 100MB)
        const maxSize = 100 * 1024 * 1024; // 100MB in bytes
        if (file.size > maxSize) {
            toast.error('File size exceeds 100MB limit');
            return;
        }

        // Validate file type
        const allowedTypes = ['image/jpeg', 'image/png', 'image/gif', 'image/webp', 'image/svg+xml'];
        if (!allowedTypes.includes(file.type)) {
            toast.error('Please select an image file (JPEG, PNG, GIF, WebP, SVG)');
            return;
        }

        setFormData(prev => ({
            ...prev,
            image_file: file,
            image_url: URL.createObjectURL(file) // Preview URL
        }));
    };

    // Handle service items
    const handleServiceItemChange = (index, value) => {
        const newItems = [...serviceItems];
        newItems[index] = value;
        
        // If this is the last item and it's not empty, add a new empty item
        if (index === newItems.length - 1 && value.trim() !== '') {
            newItems.push('');
        }
        
        // Remove empty items except the last one
        const filteredItems = newItems.filter((item, idx) => 
            item.trim() !== '' || idx === newItems.length - 1
        );
        
        setServiceItems(filteredItems);
    };

    // Handle additional images upload
    const handleAdditionalImageUpload = async (e) => {
        const file = e.target.files[0];
        if (!file) return;

        // Validate file size (max 100MB)
        const maxSize = 100 * 1024 * 1024;
        if (file.size > maxSize) {
            toast.error('File size exceeds 100MB limit');
            return;
        }

        // Validate file type
        const allowedTypes = ['image/jpeg', 'image/png', 'image/gif', 'image/webp', 'image/svg+xml'];
        if (!allowedTypes.includes(file.type)) {
            toast.error('Please select an image file (JPEG, PNG, GIF, WebP, SVG)');
            return;
        }

        try {
            toast.loading('Uploading additional image...');
            const imageUrl = await uploadToFileServer(file);
            toast.dismiss();
            toast.success('Additional image uploaded!');
            
            // Create new image object with subtitle and description
            const newImage = {
                url: imageUrl,
                subtitle: '',
                description: '',
                is_primary: false
            };
            
            setAdditionalImages(prev => [...prev, newImage]);
        } catch (error) {
            console.error('Error uploading additional image:', error);
            toast.error('Failed to upload additional image');
        }
    };

    // Handle additional image input change
    const handleAdditionalImageChange = (index, field, value) => {
        const updatedImages = [...additionalImages];
        updatedImages[index] = {
            ...updatedImages[index],
            [field]: value
        };
        setAdditionalImages(updatedImages);
    };

    // Remove additional image
    const removeAdditionalImage = (index) => {
        setAdditionalImages(prev => prev.filter((_, i) => i !== index));
    };

    // Set primary image
    const setPrimaryImage = (index) => {
        setAdditionalImages(prev => 
            prev.map((img, i) => ({
                ...img,
                is_primary: i === index
            }))
        );
    };

    // Add additional image via URL
    const addImageByURL = () => {
        const newImage = {
            url: '',
            subtitle: '',
            description: '',
            is_primary: false
        };
        setAdditionalImages(prev => [...prev, newImage]);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        
        try {
            let imageUrl = formData.image_url;

            // If a new file is selected, upload it to the file server
            if (formData.image_file) {
                toast.loading('Uploading main image to file server...');
                imageUrl = await uploadToFileServer(formData.image_file);
                toast.dismiss();
                toast.success('Main image uploaded successfully!');
            }

            // Filter out empty service items
            const filteredServiceItems = serviceItems.filter(item => item.trim() !== '');
            
            // Filter out additional images without URL
            const validAdditionalImages = additionalImages.filter(img => img.url.trim() !== '');

            // Prepare service data
            const serviceData = {
                category: formData.category,
                title: formData.title,
                description: formData.description,
                image_url: imageUrl,
                is_active: formData.is_active,
                details: {
                    services: filteredServiceItems,
                    additionalImages: validAdditionalImages
                }
            };

            if (currentServiceId) {
                // Update existing service
                console.log('Updating service with ID:', currentServiceId);
                await updateService(currentServiceId, serviceData);
                toast.success('Service updated successfully!');
            } else {
                // Create new service
                console.log('Creating new service');
                await createService(serviceData);
                toast.success('Service created successfully!');
            }
            
            // Reset form
            resetForm();
            
            // Reload services
            await loadServices();
            
        } catch (error) {
            console.error('Error saving service:', error);
            const errorMessage = error.response?.data?.message || error.message || 'Failed to save service';
            toast.error(errorMessage);
        }
    };

    const handleDelete = async (id) => {
        if (window.confirm('Are you sure you want to delete this service?')) {
            try {
                await deleteService(id);
                toast.success('Service deleted successfully!');
                await loadServices();
            } catch (error) {
                console.error('Error deleting service:', error);
                toast.error('Failed to delete service');
            }
        }
    };

    const handleToggleActive = async (id, currentStatus) => {
        try {
            await updateService(id, { is_active: !currentStatus });
            toast.success(`Service ${!currentStatus ? 'activated' : 'deactivated'}`);
            await loadServices();
        } catch (error) {
            console.error('Error toggling service status:', error);
            toast.error('Failed to update service status');
        }
    };

    const resetForm = () => {
        setFormData({
            category: '',
            title: '',
            description: '',
            image_url: '',
            image_file: null,
            is_active: true,
            details: { 
                services: [],
                additionalImages: []
            }
        });
        setCurrentServiceId(null);
        setServiceItems(['']);
        setAdditionalImages([]);
        setShowForm(false);
        setUploadProgress(0);
        setUploading(false);
        
        // Clear editingId from URL if present
        if (editingId) {
            window.history.pushState({}, '', '/admin/services');
        }
    };

    const handleEditClick = (service) => {
        setCurrentServiceId(service.id);
        
        // Parse details if it's a string
        let details = service.details;
        if (typeof details === 'string') {
            try {
                details = JSON.parse(details);
            } catch (e) {
                details = { services: [], additionalImages: [] };
            }
        }
        
        // Initialize arrays if not present
        if (!details.services) details.services = [];
        if (!details.additionalImages) details.additionalImages = [];
        
        setFormData({
            category: service.category || '',
            title: service.title || '',
            description: service.description || '',
            image_url: service.image_url || '',
            image_file: null,
            is_active: service.is_active !== undefined ? service.is_active : true,
            details: details
        });
        
        // Set service items and additional images
        setServiceItems(details.services.length > 0 ? [...details.services, ''] : ['']);
        setAdditionalImages(details.additionalImages || []);
        setShowForm(true);
    };

    const handleAddNewClick = () => {
        resetForm();
        setShowForm(true);
    };

    const handleCancelClick = () => {
        resetForm();
        if (editingId) {
            window.history.pushState({}, '', '/admin/services');
        }
    };

    const handleClearImage = () => {
        setFormData(prev => ({
            ...prev,
            image_file: null,
            image_url: ''
        }));
    };

    return (
        <div className="bg-white p-6 rounded-lg shadow">
            <div className="flex justify-between items-center mb-6">
                <h2 className="text-2xl font-bold text-gray-800">Manage Services</h2>
                <button
                    onClick={handleAddNewClick}
                    className="bg-blue-600 text-white px-4 py-2 rounded-lg hover:bg-blue-700 transition-colors"
                >
                    Add New Service
                </button>
            </div>

            {showForm && (
                <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
                    <div className="bg-white p-6 rounded-lg w-full max-w-4xl max-h-[90vh] overflow-y-auto">
                        <div className="flex justify-between items-center mb-4">
                            <h3 className="text-xl font-bold">
                                {currentServiceId ? 'Edit Service' : 'Add New Service'}
                            </h3>
                            <button
                                onClick={handleCancelClick}
                                className="text-gray-500 hover:text-gray-700"
                            >
                                ✕
                            </button>
                        </div>
                        
                        <form onSubmit={handleSubmit} className="space-y-6">
                            {/* Basic Information */}
                            <div className="bg-gray-50 p-4 rounded-lg">
                                <h4 className="text-lg font-semibold text-gray-800 mb-3">Basic Information</h4>
                                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                                    <div>
                                        <label className="block text-sm font-medium text-gray-700 mb-1">
                                            Category *
                                        </label>
                                        <input
                                            type="text"
                                            value={formData.category}
                                            onChange={(e) => setFormData({...formData, category: e.target.value})}
                                            className="w-full p-2 border border-gray-300 rounded focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                                            required
                                        />
                                    </div>
                                    
                                    <div>
                                        <label className="block text-sm font-medium text-gray-700 mb-1">
                                            Title *
                                        </label>
                                        <input
                                            type="text"
                                            value={formData.title}
                                            onChange={(e) => setFormData({...formData, title: e.target.value})}
                                            className="w-full p-2 border border-gray-300 rounded focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                                            required
                                        />
                                    </div>
                                    
                                    <div>
                                        <label className="block text-sm font-medium text-gray-700 mb-1">
                                            Status
                                        </label>
                                        <div className="flex items-center mt-2">
                                            <label className="flex items-center space-x-2">
                                                <input
                                                    type="checkbox"
                                                    checked={formData.is_active}
                                                    onChange={(e) => setFormData({...formData, is_active: e.target.checked})}
                                                    className="rounded text-blue-600 focus:ring-blue-500"
                                                    disabled={uploading}
                                                />
                                                <span className="text-sm text-gray-700">Active</span>
                                            </label>
                                        </div>
                                    </div>
                                </div>
                                
                                <div className="mt-4">
                                    <label className="block text-sm font-medium text-gray-700 mb-1">
                                        Description
                                    </label>
                                    <textarea
                                        value={formData.description}
                                        onChange={(e) => setFormData({...formData, description: e.target.value})}
                                        className="w-full p-2 border border-gray-300 rounded focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                                        rows="4"
                                        placeholder="Service description"
                                    />
                                </div>
                            </div>

                            {/* Main Image */}
                            <div className="bg-gray-50 p-4 rounded-lg">
                                <h4 className="text-lg font-semibold text-gray-800 mb-3">Main Service Image</h4>
                                
                                <div className="space-y-4">
                                    {/* File Upload */}
                                    <div className="border-2 border-dashed border-gray-300 rounded-lg p-6 text-center">
                                        <input
                                            type="file"
                                            id="image-upload"
                                            onChange={handleFileSelect}
                                            accept="image/*"
                                            className="hidden"
                                        />
                                        <label
                                            htmlFor="image-upload"
                                            className="cursor-pointer"
                                        >
                                            <div className="flex flex-col items-center">
                                                <svg className="w-12 h-12 text-gray-400 mb-3" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z"></path>
                                                </svg>
                                                <p className="text-sm text-gray-600 mb-2">
                                                    <span className="font-semibold">Click to upload</span> or drag and drop
                                                </p>
                                                <p className="text-xs text-gray-500">
                                                    PNG, JPG, GIF, WebP, SVG up to 100MB
                                                </p>
                                            </div>
                                        </label>
                                    </div>

                                    {/* Upload Progress */}
                                    {uploading && (
                                        <div className="w-full">
                                            <div className="flex justify-between text-sm text-gray-600 mb-1">
                                                <span>Uploading...</span>
                                                <span>{uploadProgress}%</span>
                                            </div>
                                            <div className="w-full bg-gray-200 rounded-full h-2">
                                                <div 
                                                    className="bg-blue-600 h-2 rounded-full transition-all duration-300"
                                                    style={{ width: `${uploadProgress}%` }}
                                                ></div>
                                            </div>
                                        </div>
                                    )}

                                    {/* Image Preview */}
                                    {formData.image_url && (
                                        <div className="relative">
                                            <p className="text-sm text-gray-600 mb-2">Preview:</p>
                                            <div className="relative inline-block">
                                                <img 
                                                    src={formData.image_url} 
                                                    alt="Preview"
                                                    className="max-w-full h-48 object-cover rounded border"
                                                    onError={(e) => {
                                                        e.target.onerror = null;
                                                        e.target.src = '/default-service.jpg';
                                                    }}
                                                />
                                                <button
                                                    type="button"
                                                    onClick={handleClearImage}
                                                    className="absolute top-2 right-2 bg-red-500 text-white rounded-full p-1 hover:bg-red-600"
                                                >
                                                    <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12"></path>
                                                    </svg>
                                                </button>
                                            </div>
                                        </div>
                                    )}

                                    {/* Direct URL Input */}
                                    <div>
                                        <p className="text-sm text-gray-600 mb-1">Or enter image URL directly:</p>
                                        <input
                                            type="url"
                                            value={formData.image_file ? '' : formData.image_url}
                                            onChange={(e) => setFormData({...formData, image_url: e.target.value, image_file: null})}
                                            className="w-full p-2 border border-gray-300 rounded focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                                            placeholder="https://example.com/image.jpg"
                                            disabled={uploading}
                                        />
                                    </div>
                                </div>
                            </div>

                            {/* Service Items */}
                            <div className="bg-gray-50 p-4 rounded-lg">
                                <h4 className="text-lg font-semibold text-gray-800 mb-3">Service Items</h4>
                                <p className="text-sm text-gray-600 mb-3">Add individual service items (one per line):</p>
                                
                                <div className="space-y-2">
                                    {serviceItems.map((item, index) => (
                                        <div key={index} className="flex items-center space-x-2">
                                            <input
                                                type="text"
                                                value={item}
                                                onChange={(e) => handleServiceItemChange(index, e.target.value)}
                                                className="flex-1 p-2 border border-gray-300 rounded focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                                                placeholder={`Service item ${index + 1}`}
                                            />
                                            {index < serviceItems.length - 1 && (
                                                <button
                                                    type="button"
                                                    onClick={() => {
                                                        const newItems = serviceItems.filter((_, i) => i !== index);
                                                        setServiceItems(newItems.length > 0 ? newItems : ['']);
                                                    }}
                                                    className="text-red-500 hover:text-red-700"
                                                >
                                                    Remove
                                                </button>
                                            )}
                                        </div>
                                    ))}
                                </div>
                            </div>

                            {/* Additional Images */}
                            <div className="bg-gray-50 p-4 rounded-lg">
                                <div className="flex justify-between items-center mb-3">
                                    <h4 className="text-lg font-semibold text-gray-800">Additional Images</h4>
                                    <button
                                        type="button"
                                        onClick={addImageByURL}
                                        className="px-3 py-1 bg-blue-600 text-white text-sm rounded hover:bg-blue-700"
                                    >
                                        Add Image by URL
                                    </button>
                                </div>
                                <p className="text-sm text-gray-600 mb-3">Add more images with their own subtitles and descriptions:</p>
                                
                                {/* Upload Additional Image */}
                                <div className="mb-4">
                                    <input
                                        type="file"
                                        id="additional-images-upload"
                                        onChange={handleAdditionalImageUpload}
                                        accept="image/*"
                                        className="hidden"
                                    />
                                    <label
                                        htmlFor="additional-images-upload"
                                        className="inline-flex items-center px-4 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700 transition-colors cursor-pointer mr-3"
                                    >
                                        <svg className="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 4v16m8-8H4"></path>
                                        </svg>
                                        Upload Additional Image
                                    </label>
                                </div>

                                {/* Additional Images List */}
                                {additionalImages.length > 0 && (
                                    <div className="space-y-4">
                                        {additionalImages.map((image, index) => (
                                            <div key={index} className="border rounded-lg p-4 bg-white">
                                                <div className="flex justify-between items-start mb-3">
                                                    <div className="flex items-center space-x-3">
                                                        <span className="font-medium text-gray-700">
                                                            Image {index + 1}
                                                        </span>
                                                        <button
                                                            type="button"
                                                            onClick={() => setPrimaryImage(index)}
                                                            className={`px-2 py-1 text-xs rounded ${
                                                                image.is_primary 
                                                                    ? 'bg-green-100 text-green-800' 
                                                                    : 'bg-gray-100 text-gray-600 hover:bg-gray-200'
                                                            }`}
                                                        >
                                                            {image.is_primary ? 'Primary' : 'Set as Primary'}
                                                        </button>
                                                    </div>
                                                    <button
                                                        type="button"
                                                        onClick={() => removeAdditionalImage(index)}
                                                        className="text-red-500 hover:text-red-700"
                                                    >
                                                        Remove
                                                    </button>
                                                </div>
                                                
                                                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                                                    <div>
                                                        <label className="block text-sm font-medium text-gray-700 mb-1">
                                                            Image URL *
                                                        </label>
                                                        <input
                                                            type="url"
                                                            value={image.url}
                                                            onChange={(e) => handleAdditionalImageChange(index, 'url', e.target.value)}
                                                            className="w-full p-2 border border-gray-300 rounded focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                                                            placeholder="https://example.com/image.jpg"
                                                            required
                                                        />
                                                    </div>
                                                    
                                                    <div>
                                                        <label className="block text-sm font-medium text-gray-700 mb-1">
                                                            Subtitle
                                                        </label>
                                                        <input
                                                            type="text"
                                                            value={image.subtitle}
                                                            onChange={(e) => handleAdditionalImageChange(index, 'subtitle', e.target.value)}
                                                            className="w-full p-2 border border-gray-300 rounded focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                                                            placeholder="Optional subtitle for this image"
                                                        />
                                                    </div>
                                                    
                                                    <div className="md:col-span-2">
                                                        <label className="block text-sm font-medium text-gray-700 mb-1">
                                                            Description
                                                        </label>
                                                        <textarea
                                                            value={image.description}
                                                            onChange={(e) => handleAdditionalImageChange(index, 'description', e.target.value)}
                                                            className="w-full p-2 border border-gray-300 rounded focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                                                            rows="2"
                                                            placeholder="Optional description for this image"
                                                        />
                                                    </div>
                                                </div>
                                                
                                                {/* Image Preview */}
                                                {image.url && (
                                                    <div className="mt-3">
                                                        <p className="text-sm text-gray-600 mb-2">Preview:</p>
                                                        <div className="relative inline-block">
                                                            <img 
                                                                src={image.url} 
                                                                alt={image.subtitle || `Additional image ${index + 1}`}
                                                                className="max-w-full h-32 object-cover rounded border"
                                                                onError={(e) => {
                                                                    e.target.onerror = null;
                                                                    e.target.src = '/default-service.jpg';
                                                                }}
                                                            />
                                                        </div>
                                                    </div>
                                                )}
                                            </div>
                                        ))}
                                    </div>
                                )}
                            </div>

                            {/* Form Actions */}
                            <div className="flex justify-end space-x-3 pt-4">
                                <button
                                    type="button"
                                    onClick={handleCancelClick}
                                    className="px-4 py-2 border border-gray-300 text-gray-700 rounded hover:bg-gray-50 disabled:opacity-50"
                                    disabled={uploading}
                                >
                                    Cancel
                                </button>
                                <button
                                    type="submit"
                                    className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700 disabled:opacity-50 disabled:cursor-not-allowed"
                                    disabled={uploading}
                                >
                                    {uploading ? (
                                        <span className="flex items-center">
                                            <svg className="animate-spin -ml-1 mr-3 h-4 w-4 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                                                <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                                                <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                                            </svg>
                                            Uploading...
                                        </span>
                                    ) : currentServiceId ? 'Update Service' : 'Create Service'}
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            )}

            {loading ? (
                <div className="flex justify-center items-center h-64">
                    <div className="text-center">
                        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto"></div>
                        <p className="mt-4 text-gray-600">Loading services...</p>
                    </div>
                </div>
            ) : services.length === 0 ? (
                <div className="text-center py-12">
                    <p className="text-gray-500 text-lg">No services found</p>
                    <p className="text-gray-400 mt-2">Add your first service to get started</p>
                </div>
            ) : (
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                    {services.map(service => {
                        // Parse details to get additional images count
                        let additionalImagesCount = 0;
                        if (service.details) {
                            let details = service.details;
                            if (typeof details === 'string') {
                                try {
                                    details = JSON.parse(details);
                                } catch (e) {
                                    details = {};
                                }
                            }
                            if (details.additionalImages && Array.isArray(details.additionalImages)) {
                                additionalImagesCount = details.additionalImages.length;
                            }
                        }
                        
                        return (
                            <div key={service.id} className="border border-gray-200 rounded-lg p-4 hover:shadow-md transition-shadow">
                                {service.image_url && (
                                    <img 
                                        src={service.image_url} 
                                        alt={service.title}
                                        className="w-full h-48 object-cover rounded mb-4"
                                        onError={(e) => {
                                            e.target.onerror = null;
                                            e.target.src = '/default-service.jpg';
                                        }}
                                    />
                                )}
                                <div className="flex justify-between items-start mb-2">
                                    <h3 className="font-semibold text-lg text-gray-800">{service.title}</h3>
                                    <button
                                        onClick={() => handleToggleActive(service.id, service.is_active)}
                                        className={`px-2 py-1 rounded text-xs ${
                                            service.is_active 
                                                ? 'bg-green-100 text-green-800' 
                                                : 'bg-red-100 text-red-800'
                                        }`}
                                    >
                                        {service.is_active ? 'Active' : 'Inactive'}
                                    </button>
                                </div>
                                
                                <p className="text-gray-600 text-sm mb-2">
                                    <span className="font-medium">Category:</span> {service.category || 'Uncategorized'}
                                </p>
                                <p className="text-gray-700 mb-4 line-clamp-3">{service.description}</p>
                                
                                {/* Show number of additional images */}
                                {additionalImagesCount > 0 && (
                                    <div className="text-sm text-gray-500 mb-3">
                                        +{additionalImagesCount} additional image{additionalImagesCount !== 1 ? 's' : ''}
                                    </div>
                                )}
                                
                                <div className="flex justify-between items-center pt-4 border-t">
                                    <div className="flex space-x-2">
                                        <button
                                            onClick={() => handleEditClick(service)}
                                            className="text-blue-600 hover:text-blue-800 text-sm font-medium"
                                        >
                                            Edit
                                        </button>

                                        <Link
                                            to={`/admin/services/${service.id}`}
                                            className="text-green-600 hover:text-green-800 text-sm font-medium"
                                        >
                                            View Details
                                        </Link>

                                        <button
                                            onClick={() => handleDelete(service.id)}
                                            className="text-red-600 hover:text-red-800 text-sm font-medium"
                                        >
                                            Delete
                                        </button>
                                    </div>
                                </div>
                            </div>
                        );
                    })}
                </div>
            )}
        </div>
    );
};

export default ServiceManager;